module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loaded) ? _c('div', [_c('div', {
    staticClass: "categories shrinker"
  }, _vm._l((_vm.breakoutTracks), function(track) {
    return _c('div', {
      staticClass: "categories__category"
    }, [(!track.hasSessions) ? _c('div', {
      staticClass: "category-card category-card--no-sessions"
    }, [_c('p', [_vm._v(_vm._s(track.category) + "\n                ")]), _c('div', {
      staticClass: "category-card__no-sessions-label"
    }, [_vm._v("More info coming soon!")])]) : _vm._e(), _vm._v(" "), (track.hasSessions) ? _c('div', {
      staticClass: "category-card",
      on: {
        "click": function($event) {
          _vm.setTrack(track)
        }
      }
    }, [_c('p', [_vm._v(_vm._s(track.category))])]) : _vm._e()])
  }))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ae7c22c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./source/js/components/BreakoutTracks.vue
// module id = 70
// module chunks = 1